import React from "react";

const BookNow = () => {
  return (
    <>
      <div className="container">
        <div className="bookNow my-5">
          <div className="row align-items-center">
            <div className="col-md-6 ps-md-5">
              <div className="heading-main">
                <span className="badge rounded-pill text-bg-warning">
                    Book Now
                </span>
                <h2 className="mb-3">Better Consultation, Better Outcomes.</h2>
                <p>Our company achieves an annual growth of up to 30%. If you're result-driven and eager to take the initiative, reach out and join our team!</p>
                <button className="btn btn-primary p-2 pe-3 d-flex align-items-center mt-4"><img src="images/call.svg" alt="Call Booking" /> +91 78782 41849</button>
              </div>
            </div>
            <div className="col-md-6">
                <img src="images/book-now.png" alt="Book Now" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookNow;
